/* eslint-disable no-nested-ternary */
import { useMemo, useState } from 'react';
import Button from '../../../Components/Button';
import getPurchasableStoreItemIcon from '../../../Components/utils/getPurchasableStoreItemIcon';
import StarIcon from '../../../icons/Star';
import { useAppSelector } from '../../../store';

export type StoreItemCardRewardType = 'common' | 'gold'

type TStoreItem = {
  id: number;
  coins: number
  energy: number
  boost: number
  price: number
  icon: string;
  rewardType: StoreItemCardRewardType
  isPackage?: boolean
  description: string
  name: string
}

type StoreCardProps = {
    storeItem: TStoreItem
    onPurchase: () => Promise<void>;
    onOpenInvoice: (invoiceLink: string) => void
}

function StoreCard({ storeItem, onPurchase: purchaseHandler, onOpenInvoice }: StoreCardProps) {
  const { list: paymentsList } = useAppSelector(({ payments }) => payments);

  const [isLoading, setIsLoading] = useState(false);

  const activePayment = useMemo(() => paymentsList.find((p) => p.item_type === 'store' && p.item_id === storeItem.id && p.status === 'pending'), [paymentsList]);

  const onPurchase = async () => {
    setIsLoading(true);

    await purchaseHandler();

    setIsLoading(false);
  };

  const onClick = () => {
    if (activePayment) {
      onOpenInvoice(activePayment.invoice_link);
    } else {
      onPurchase();
    }
  };

  return (
    <div className={`store-item ${storeItem.rewardType} p-1 pb-4 text-center font-Bangers text-lg leading-[19.15px] flex flex-col justify-between`}>
      <p className="text-lg font-bold">
        {storeItem.name}
      </p>
      <div
        className={`main-gradient-border w-fit px-2 font-Bangers text-[10px] rounded-10 flex items-center mx-auto store-item-boost-bg 
        ${storeItem.rewardType}
        ${storeItem.rewardType === 'common' ? 'text-dodgerBlue200' : 'text-deepBlue'}
        `}
      >
        {storeItem.boost > 0 && (
        <>
          {storeItem.boost.toFixed(2)}
          %
          {' '}
          Boost
        </>
        )}

      </div>
      <div className="mx-auto flex items-center justify-center mt-2 h-[80px]">
        {getPurchasableStoreItemIcon(storeItem.icon)}
      </div>
      <div className="px-3 mt-3">
        <Button
          className="w-full rounded-[8px] text-base flex justify-center items-center gap-1"
          onClick={onClick}
          disabled={isLoading}
        >
          {storeItem.price}
          <StarIcon size={24} className="-mt-1" />
        </Button>
      </div>
    </div>
  );
}

export default StoreCard;
